import React from 'react';
import ServicePage from '../components/services/ServicePage';
import signboards from '../data/services/signboards';

const Signboards: React.FC = () => <ServicePage data={signboards} />;

export default Signboards;
